// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"dac9a9b6","112":"c0d6e4b7","453":"03346f77"}[chunkId] + ".chunk.js";
};